import "./index.css";
import AppRouting from "./core/routes/AppRouting";
import { HelmetProvider } from "react-helmet-async";

export function App() {
  return (
    <HelmetProvider>
      <AppRouting />
    </HelmetProvider>
  );
}

export default App;
